import { API_MODULES } from 'constants/api-v2'
import useSWR from 'hooks/swr'
import { useMemo } from 'react'
import type { Module } from 'shared/types'

export function useModules() {
  const { data, error, isValidating, mutate } = useSWR(API_MODULES)

  const modules: Module[] = useMemo(() => (Array.isArray(data) ? data : []), [data])

  const enabledModules = useMemo(() => modules.filter(module => module.enabled === true), [modules])

  const hasTraining = enabledModules.some(module => module.slug === 'training')
  const hasWorkplace = enabledModules.some(module => module.slug === 'workplace')
  const hasSafety = enabledModules.some(module => module.slug === 'safety')
  const isSafetyStandalone = hasSafety && !hasTraining

  return useMemo(
    () => ({
      modules,
      enabledModules,
      isSafetyStandalone,
      hasTraining,
      hasWorkplace,
      hasSafety,
      isLoading: !data && !error && isValidating,
      error,
      mutate,
    }),
    [
      data,
      enabledModules,
      error,
      hasSafety,
      hasTraining,
      hasWorkplace,
      isSafetyStandalone,
      isValidating,
      modules,
      mutate,
    ],
  )
}

export type UseModulesOutput = ReturnType<typeof useModules>
